import { MagnifyingGlass } from '@phosphor-icons/react';
import { Card } from '../ui/card';

const MyNotebooksLoader = () => {
  return (
    <div className="w-full min-w-0 overflow-hidden px-4 py-6 md:px-6 lg:px-8">
      {/* Desktop Header */}
      <div className="hidden md:flex flex-col md:flex-row md:items-start justify-between gap-4 mb-8">
        <div className="flex-1 space-y-3">
          <div className="h-6 w-40 bg-gray-300 rounded animate-pulse" />
          <div className="h-4 w-64 bg-gray-200 rounded animate-pulse" />
          <div className="flex items-center gap-2 mt-2">
            <div className="h-6 w-32 bg-gray-200 rounded animate-pulse" />
            <div className="h-6 w-32 bg-gray-200 rounded animate-pulse" />
          </div>
        </div>
        <div className="w-52 lg:w-60 relative">
          <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
            <MagnifyingGlass className="w-5 h-5 text-gray-300" />
          </div>
          <div className="w-full pl-10 pr-4 py-2 rounded-full border bg-gray-200 animate-pulse" />
        </div>
      </div>

      {/* Sort Options */}
      <div className="hidden md:flex gap-2 flex-wrap mb-10">
        {[...Array(5)].map((_, i) => (
          <div key={i} className="h-7 w-28 bg-gray-200 rounded-full animate-pulse" />
        ))}
      </div>

      {/* Notebook Card Grid */}
      <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4 md:gap-6">
        {[...Array(8)].map((_, i) => (
          <Card
            key={i}
            className="bg-gray-100 rounded-lg shadow-none p-4 animate-pulse h-32 flex flex-col justify-between"
          >
            <div className="h-5 w-3/4 bg-gray-300 rounded" />
            <div className="h-4 w-1/2 bg-gray-300 rounded" />
            <div className="flex gap-2 mt-2">
              <div className="h-3 w-16 bg-gray-300 rounded" />
              <div className="h-3 w-20 bg-gray-300 rounded" />
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default MyNotebooksLoader;
